import moment from 'moment';

import useAppSelector from './useAppSelector';

/**
 * @returns {[boolean, import("../../../types/vansite").VanSite.Pass | null]}
 */

const usePass = () => {
  /** @type {import("@vansite/ts-sharetribe-flex-sdk").CurrentUser} */
  const currentUser = useAppSelector((state) => state.user.currentUser);

  if (!currentUser) return [false, null];

  /** @type {import("../../../types/vansite").VanSite.Pass} */
  const pass = currentUser?.attributes?.profile?.privateData?.annualPass;

  if (!pass) return [false, null];

  const valid = pass && moment().utc().isBefore(moment.utc(pass.validUntil));

  return [valid, pass];
};

export default usePass;
